import { render, staticRenderFns } from "./articulation.vue?vue&type=template&id=556a28bc&"
import script from "./articulation.vue?vue&type=script&lang=js&"
export * from "./articulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports